import { render, staticRenderFns } from "./settlement-discount.vue?vue&type=template&id=23a527ae&scoped=true"
import script from "./settlement-discount.vue?vue&type=script&lang=js"
export * from "./settlement-discount.vue?vue&type=script&lang=js"
import style0 from "./settlement-discount.vue?vue&type=style&index=0&id=23a527ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a527ae",
  null
  
)

export default component.exports